import { FeatureDefinition } from '../entities';

export const solidFormExperiment = 'hypno-healing-thinking';

export enum SolidFormExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const solidFormDefaultFeature = {
  flow: 'default_flow',
};

export const solidFormExperimentFeature = {
  flow: 'default_flow_solid',
};

export const solidFormExperimentConfig: FeatureDefinition = {
  defaultValue: solidFormDefaultFeature,
};
